import React from "react";
import { FichaFinanceiraAssistidoService, PlanoService } from "../../services";
import { Botao, Row, Col, Box, Alerta, TipoAlerta, TamanhoBotao } from "@intechprev/componentes-web";
import { MasterPage } from "..";
import { Link } from "react-router-dom";
import ContrachequeDetalhe from "./ContrachequeDetalhe";
import moment from "moment";

import { PlanoVinculadoEntidade } from "./../../entidades";
import { NumFuncionalidade } from "../MasterPage";
import { reCAPTCHA } from "../../helpers";

export { ContrachequeDetalhe };

interface Props { }

interface State {
  planos: Array<PlanoVinculadoEntidade>;
  especies: Array<any>;
  msgSemContracheque: string;
}

export class Contracheque extends React.Component<Props, State> {
  private recaptcha = new reCAPTCHA("contracheque");

  private page = React.createRef<MasterPage>();

  constructor(props: Props) {
    super(props);

    this.state = {
      planos: [],
      especies: [],
      msgSemContracheque: "Aguarde enquanto o sistema carrega suas informações.",
    };
  }

  componentDidMount = async () => {
    try {
      await this.page.current.alternarLoading();

      const planos = await PlanoService.Buscar();

      await this.buscarDatas(planos);

      if (this.state.especies.length === 0) {
        await this.setState({
          msgSemContracheque: "Nenhum contracheque disponível para este plano.",
        });
      }

      await this.page.current.alternarLoading();
    } catch (err) {
      console.log(err);
    }
  };

  buscarDatas = async (planos: Array<PlanoVinculadoEntidade>) => {
    for (var i = 0; i < planos.length; i++) {
      // var datas = await FichaFinanceiraAssistidoService.BuscarPorPlano(planos[i].CD_PLANO);
      var datas = await FichaFinanceiraAssistidoService.BuscarDatas(planos[i].CD_PLANO);
      //planos[i].contracheque = datas;

      await this.setState({
        planos: [...this.state.planos, planos[i]],
        especies: datas,
      });
    }
  };

  gerarRelatorio = async (cdPlano: string, dataReferencia: string, cdTipoFolha: string, cdEspecie: string, enviarPorEmail: boolean) => {
    try {
      const relatorio = await FichaFinanceiraAssistidoService.GetRelatorio(cdPlano, dataReferencia, cdTipoFolha, cdEspecie, enviarPorEmail);

      if (navigator.msSaveBlob) {
        // IE10+ : (has Blob, but not a[download] or URL)
        return navigator.msSaveBlob(new Blob([relatorio]), "contracheque.pdf");
      } else {
        const url = window.URL.createObjectURL(new Blob([relatorio]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "contracheque.pdf");
        document.body.appendChild(link);

        link.click();
        URL.revokeObjectURL(url);
      }
    } catch (err) {
      console.error(err);
    }
  };

  montarLink = (valor: any, cdPlano: string) => {
    const dataReferencia = moment(valor.DT_REFERENCIA, "DD/MM/YYYY").format("DD.MM.YYYY");
    return `/contrachequedetalhes/${cdPlano}/${dataReferencia}/${valor.CD_TIPO_FOLHA}/${valor.CD_ESPECIE}`;
  };

  renderTodasListas = (lista: any, cdPlano: string): any => {
    if (lista.length > 0) {
      const listas = lista.map((valor: any, index: number) => {
        return (
          <tr key={index}>
            <td>{moment(valor.DT_REFERENCIA, "DD/MM/YYYY").format("MM/YYYY")}</td>
            <td>{valor.DS_TIPO_FOLHA}</td>
            <td className="text-info">{valor.VAL_BRUTO.toLocaleString("pt-br", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
            <td className="text-danger">{valor.VAL_DESCONTOS.toLocaleString("pt-br", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
            <td className="text-success">{valor.VAL_LIQUIDO.toLocaleString("pt-br", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
            <td>
              <Link className={"btn btn-primary btn-sm"} to={this.montarLink(valor, cdPlano)}>
                Abrir
              </Link>
            </td>
            <td>
              <Botao
                titulo={"Baixar PDF"}
                className={"btn btn-primary"}
                tamanho={TamanhoBotao.pequeno}
                onClick={() =>
                  this.gerarRelatorio(
                    cdPlano,
                    moment(valor.DT_REFERENCIA, "DD/MM/YYYY").format("DD.MM.YYYY"),
                    valor.CD_TIPO_FOLHA,
                    valor.CD_ESPECIE,
                    false
                  )
                }
                usaLoading
              />
            </td>
          </tr>
        );
      });

      return (
        <table className={"table"}>
          <thead>
            <tr>
              <th>Referência</th>
              <th>Tipo</th>
              <th>Bruto</th>
              <th>Descontos</th>
              <th>Líquido</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>{listas}</tbody>
        </table>
      );
    }

    return <div>Nenhum contracheque disponível para este plano.</div>;
  };

  renderTodasEspecies = () => {
    const especies = this.state.especies.map((especie: any, index: number) => {
      return (
        <Col key={index} className={"col-lg-8"}>
          <Box titulo={""}>
            <div className={"cc-title"}>{especie.Especie.DS_PLANO}</div>
            <br />

            <div className={"mb-4"}>
              <b>ESPÉCIE:</b> {especie.Especie.DS_ESPECIE}
              <br />
              {/* <b>PROCESSO:</b> {especie.Especie.NUM_PROCESSO}/{especie.Especie.ANO_PROCESSO} */}
            </div>

            {this.renderTodasListas(especie.Lista, especie.Especie.CD_PLANO)}
          </Box>
        </Col>
      );
    });

    return especies;
  };

  renderSemContracheque = () => {
    if (this.state.especies.length === 0) {
      return <Alerta tipo={TipoAlerta.danger} mensagem={this.state.msgSemContracheque} />;
    }
    return null;
  };

  render() {
    return (
      <MasterPage Funcionalidade={NumFuncionalidade.CONTRACHEQUE_ASISSTIDOS_PENSIONISTAS} {...this.props} ref={this.page}>
        <Row>{this.renderTodasEspecies()}</Row>

        {this.renderSemContracheque()}
      </MasterPage>
    );
  }
}
